import { useDispatch, useSelector } from 'react-redux'
import { getActiveCommunity } from '../../../utility/activeCommunity'
import { Link } from 'react-router-dom'
import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { getCoachPrograms } from '../../../actions/programActions'
import { perPage } from '../../../reducers/groupProgramsReducer'
import CoachProgramsList from './CoachProgramsList'
import SearchInput from '../../common/SearchInput'
import NoPrograms from './EmptyProgramsList'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

import { ReactComponent as OutsideLinkIcon } from '../../../assets/images/common/icons/outside-link-icon.svg'
import styles from './CoachProgramsFilterBar.module.scss'
import { debounce } from '../../../utility/debounceHelper'

const CoachProgramsDraftTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const draft = useSelector(state => state.groupPrograms.draft)
  const [searchInput, setSearchInput] = useState(draft.search || '')
  const user = useSelector(state => state.user.current_user)
  const { timezone, id } = getActiveCommunity(user) || {}

  const fetchDraftPrograms = () => {
    dispatch(getCoachPrograms({
      filters: { draft: 'true', search: draft.search },
      page: draft.page + 1,
      perPage: perPage,
    }))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchPrograms = useCallback(
    debounce((value) => {
      dispatch(getCoachPrograms({
        filters: { draft: 'true', search: value },
        page: 1,
        perPage: perPage,
      }))
    }),
    []
  )

  const handleSearchUpdated = (value) => {
    setSearchInput(value)
    debouncedFetchPrograms(value)
  }

  return (
    <>
      <div className={styles.coachProgramsFilterBar}>
        <div className={styles.programsSearchBar}>
          <SearchInput
            placeholder={t('programs.groups.draftTab.searchPrograms')}
            onChange={(e) => handleSearchUpdated(e.target.value)}
            value={searchInput}
          />
        </div>
        <div className='d-flex flex-grow-1 align-items-center'/>
        <Link to={`/landing/${id}`} target='_blank' className='d-flex mr-5 align-items-center view-community-link'>
          <OutsideLinkIcon id='outsideLinkIcon'/>
          <span className='view-community-label'>{t('programs.groups.draftTab.viewLandingPage')}</span>
        </Link>
      </div>

      {
        draft.programs.length > 0 ?
          <CoachProgramsList
            programs={draft.programs}
            timezone={timezone}
            hasMore={draft.hasMore}
            fetchPrograms={fetchDraftPrograms}
            status='draft'
          />
          :
          draft.hasMore === false ?
            (draft.search) ? (
              <NoPrograms
                title={t('programs.groups.draftTab.noDraftsFound')}
                subtitle={t('programs.groups.draftTab.noDraftsMatchClearFilters')}
              />
            ) : (
              <NoPrograms
                title={t('programs.groups.draftTab.noDraftsAvailable')}
                subtitle={t('programs.groups.createPrompt')}
              />
            ) : (
              <Loader message={t('programs.groups.loadingPrograms')} />
            )
      }
    </>
  )
}

export default CoachProgramsDraftTab
